import { jsx as _jsx } from "react/jsx-runtime";
import { TriangleDown as TriangleDownIcon } from "@air/next-icons";
import classNames from "classnames";
/**
 * This is used in the side boards tree to open and close boards lists
 */ export const RotatingDowntick = (param)=>{
    let { rotate } = param;
    return /*#__PURE__*/ _jsx(TriangleDownIcon, {
        className: classNames("flex h-4 w-4 items-center justify-center text-grey-9 transition-transform", rotate && "-rotate-90")
    });
};
